module.exports = __webpack_public_path__ + "static/img/honor.f585ad1.png";


//////////////////
// WEBPACK FOOTER
// ./static/walkInto/honor.png
// module id = xRRu
// module chunks = 1